import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import VerticalLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalLeftOutlined";
import AntdIcon from "../components/AntdIcon";
var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalLeftOutlinedSvg
  }));
};

/**![vertical-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2MiAxNjRoLTY0Yy00LjQgMC04IDMuNi04IDh2Njg4YzAgNC40IDMuNiA4IDggOGg2NGM0LjQgMCA4LTMuNiA4LThWMTcyYzAtNC40LTMuNi04LTgtOHptLTUwOCAwdjcyLjRjMCA5LjUgNC4yIDE4LjQgMTEuNCAyNC41TDU2NC42IDUxMiAyNjUuNCA3NjMuMWMtNy4yIDYuMS0xMS40IDE1LTExLjQgMjQuNVY4NjBjMCA2LjggNy45IDEwLjUgMTMuMSA2LjFMNjg5IDUxMiAyNjcuMSAxNTcuOUE3Ljk1IDcuOTUgMCAwMDI1NCAxNjR6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(VerticalLeftOutlined);
if ("production" !== 'production') {
  RefIcon.displayName = 'VerticalLeftOutlined';
}
export default RefIcon;